import './NotificationCard.scss';

import { type FC, useEffect, useState } from 'react';

import { CheckSVG, ErrorSVG } from '../../components/reusable/svgs';
import { useReduxActions } from '../../hooks/use-redux-actions';

interface NotificationCardProps {
	notice: string;
	duration?: number;
	status?: boolean;
}

const NotificationCard: FC<NotificationCardProps> = ({ notice, duration = 3000, status = true }) => {
	const actions = useReduxActions();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		// Show the notification when the component is mounted
		setVisible(!!notice);

		// Hide the notification after the specified duration
		const timer = setTimeout(() => {
			setVisible(false);
		}, duration);

		const ndtimer = setTimeout(() => {
			actions?.notificationGlobal('', status);
		}, duration + 1000);

		// Cleanup the timer when the component is unmounted
		return () => {
			clearTimeout(timer);
			clearTimeout(ndtimer);
		};
	}, [notice]);

	return (
		<div className={`notification-card ${visible ? 'show' : ''} ${status ? 'success' : 'error'}`}>
			<div className='f-row-10 align-items-center'>
				<p className='m-0 text-small'>{notice}</p>
				<div
					className='hw-mx f-row aic jcc'
					style={{ width: '15px', height: '15px' }}
				>
					{status ? <CheckSVG color='#1B6B4A' /> : <ErrorSVG />}
				</div>
			</div>
		</div>
	);
};

export default NotificationCard;
